module.exports = __webpack_public_path__ + "img/3.dc0e67c2.png";